import controller from './sensors.controller';

const template = require('./sensors.html');

export default {
    template,
    controller
};
